import React, { useCallback, useEffect, useRef } from 'react'

import { Container, Toggle, Menu } from './styles'

export type IOnToggle = (show?: boolean) => void

interface IDropdown {
  toggle: JSX.Element
  onToggle?: IOnToggle
}

export const Dropdown: React.FC<IDropdown> = ({
  toggle,
  children,
  ...props
}) => {
  const containerRef = useRef(null)

  const handleClick = useCallback(
    (event: MouseEvent) => {
      const containerEl: Node & Element = containerRef.current!

      if (event.target instanceof Node && containerEl.contains(event.target)) {
        return
      }

      containerEl.classList.remove('show')
      props.onToggle && props.onToggle(false)
    },
    [containerRef]
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [handleClick])

  const onToggle: React.MouseEventHandler<HTMLDivElement> = () => {
    const containerEl: Element = containerRef.current!

    if (!containerEl.classList.contains('show')) {
      containerEl.classList.add('show')
      props.onToggle && props.onToggle(true)
      return
    }

    containerEl.classList.remove('show')
    props.onToggle && props.onToggle(false)
  }

  return (
    <Container ref={containerRef} className='dropdown'>
      <Toggle onClick={onToggle}>{toggle}</Toggle>
      <Menu>{children}</Menu>
    </Container>
  )
}
